var render = function render(){var _vm=this,_c=_vm._self._c;return _c('symbol',{attrs:{"id":`${_vm.prefix}error-34`,"viewBox":"0 0 34 34"}},[_c('circle',{staticClass:"sign",attrs:{"cx":"17","cy":"17","r":"16","stroke-width":"2","fill":"none"}}),_c('path',{staticClass:"sign",attrs:{"d":"M14,14 20,20 M20,14 14,20","stroke-width":"2","fill":"none"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }